<div mode="card" >
    <div class="top_panel">
      <h3>Manage Optional Items</h3>
      <span (click)="close()" class="close">
          <img src="https://cdn.elitehw.com/images/cross.webp" />
      </span>
    </div>
    <div class="table_area" *ngIf="step === 1">
      <div class="table-responsive" style="text-align: center;" *ngIf="loading">
        Please Wait...
      </div>
      <div class="table-responsive" style="text-align: center;" *ngIf="itemList?.length === 0">
        No data found
      </div>
      <div class="table-responsive" *ngIf="itemList?.length > 0">
        <table class="table table-hover" width="100%">
          <thead>
            <tr>
              <th class="titletr">Title</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of itemList">
              <td width="30px">
                <input type="checkbox" style="cursor: pointer;" (click)="$event.stopPropagation()" (change)="changeOptionalItems($event,item)"
                  [checked]="selection.isSelected(item)">
              </td>
              <td class="titletr" title="Title">{{item?.title}}</td>
              <td title="Price">{{item?.standardPrice | currency}}</td>
            </tr>
            <tr>
              <td colspan="4" *ngIf="show < total"></td>
            </tr>
          </tbody>
          
        </table>
       
      </div>
      <div class="flexwrap" style="margin-top: 10px;">
        <div class="lower_sec" *ngIf="itemList?.length > 0">
          <p>Total Optional Item Amount: <span [ngStyle]="{'color':totalPrice < 0 ?'red':'green' }">{{totalPrice | currency}}</span></p>
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" style="width:100%;">
            <button mat-button class="can-button" (click)="cancel()"><span>Cancel</span></button>
            <button mat-button class="sub-button" (click)="checkAmountAndProced()">{{totalPrice === 0 ? 'save' : 'Next'}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="refund_process" *ngIf="step === 2">
      <div class="tab_panel">
        <mat-tab-group (selectedTabChange)="onTabChange($event)">
          <mat-tab label="Credit card">
            <form [formGroup]="cardDetailsForm">
              <div class="card_detail">
                <div class="card_panel full">
                  <label> Card Holder Name </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Card Holder Name"
                      formControlName="cardHoldarName"
                      [readOnly]="refundToDefaultCard"
                    />
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cardHoldarName'].touched &&
                        cardDetailsForm.controls['cardHoldarName'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full">
                  <label> Card Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="**** **** **** ****"
                      formControlName="cardNumber"
                      [hiddenInput]="true"
                      [mask]="
                        cardType == 'American Express'
                          ? 'XXXX XXXXXX X0000'
                          : 'XXXX XXXX XXXX 0000'
                      "
                      (ngModelChange)="detectCardType($event)"
                      [readOnly]="refundToDefaultCard"
                    />
                    <span
                      *ngIf="cardType && cardType == 'Visa'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/visa-card-logo.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="cardType && cardType == 'Mastercard'"
                      class="cardlogo mastercard"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/master-card.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="cardType && cardType == 'American Express'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/American-Express.png"
                        alt=""
                      />
                    </span>
                    <span
                      *ngIf="cardType && cardType == 'Discover'"
                      class="cardlogo"
                    >
                      <img
                        src="https://cdn.elitehw.com/images/discover.png"
                        alt=""
                      />
                    </span>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cardNumber'].touched &&
                        cardDetailsForm.controls['cardNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cardNumber'].touched &&
                        cardDetailsForm.controls['cardNumber'].hasError(
                          'mask'
                        )
                      "
                    >
                      Enter Valid Card Number
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> Expiration Date </label>
                  <span>
                    <input
                      type="text"
                      placeholder="00/00"
                      formControlName="monthYear"
                      mask="00/00"
                      [readOnly]="refundToDefaultCard"
                    />
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        )
                      "
                    >
                      Enter valid Expiry month and year.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryMonth'].hasError(
                          'max'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        cardDetailsForm.controls['expiryYear'].valid
                      "
                    >
                      Enter Valid Expire Month.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryMonth'].hasError(
                          'min'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        )
                      "
                    >
                      Expiry Month value should be greater then 1.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryYear'].hasError(
                          'min'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        cardDetailsForm.controls['expiryMonth'].valid
                      "
                    >
                      Enter Valid Expire Year.
                    </mat-error>
                    <mat-error
                      *ngIf="
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryMonth'].hasError(
                          'max'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'required'
                        ) &&
                        cardDetailsForm.controls['monthYear'].touched &&
                        cardDetailsForm.controls['expiryYear'].hasError(
                          'min'
                        ) &&
                        !cardDetailsForm.controls['monthYear'].hasError(
                          'mask'
                        )
                      "
                    >
                      Enter valid expire month and year.
                    </mat-error>
                    <mat-error *ngIf="
                      !cardDetailsForm.controls['monthYear'].hasError('required') && 
                      cardDetailsForm.controls['expiryMonth'].hasError('notValid') && 
                      !cardDetailsForm.controls['monthYear'].hasError('mask') &&
                      cardDetailsForm.controls['monthYear'].touched &&
                      !cardDetailsForm.controls['expiryYear'].hasError('min')">
                          Enter Valid Expire Month.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> CVV </label>
                  <span>
                    <input
                      type="password"
                      placeholder="CVV"
                      formControlName="cvv"
                      [mask]="cardType == 'American Express' ? '0000' : '000'"
                      [readOnly]="refundToDefaultCard"
                    />
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cvv'].touched &&
                        cardDetailsForm.controls['cvv'].hasError('required')
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['cvv'].touched &&
                        cardDetailsForm.controls['cvv'].hasError('mask')
                      "
                    >
                      Enter valid cvv code.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full" *ngIf="checkTransactionNumber">
                  <label> Transaction Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Transaction Number"
                      formControlName="transactionNumber"
                    />
                    <mat-error
                      *ngIf="
                        cardDetailsForm.controls['transactionNumber']
                          .touched &&
                        cardDetailsForm.controls[
                          'transactionNumber'
                        ].hasError('required')
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Bank" *ngIf="!refundToDefaultCard">
            <form [formGroup]="bankDetailsForm">
              <div class="card_detail">
                <div class="card_panel full">
                  <label> Account Holder Name </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Account Holder Name"
                      formControlName="nameOnAccount"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['nameOnAccount'].touched &&
                        bankDetailsForm.controls['nameOnAccount'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['nameOnAccount'].touched &&
                        bankDetailsForm.controls['nameOnAccount'].hasError(
                          'minlength'
                        )
                      "
                    >
                      Name must be minimum 2 digits
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full">
                  <label> Account Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="**** **** **** ****"
                      mask="0000*"
                      minlength="4"
                      formControlName="accountNumber"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['accountNumber'].touched &&
                        bankDetailsForm.controls['accountNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['accountNumber'].touched &&
                        bankDetailsForm.controls['accountNumber'].hasError(
                          'minlength'
                        )
                      "
                    >
                      Account Number must be minimum 4 digits.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> Routing No </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Routing No"
                      formControlName="routingNumber"
                      mask="000000000"
                      (ngModelChange)="getBankDetail()"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['routingNumber'].touched &&
                        bankDetailsForm.controls['routingNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['routingNumber'].touched &&
                        (bankDetailsForm.controls['routingNumber'].hasError(
                          'minlength'
                        ) ||
                          bankDetailsForm.controls['routingNumber'].hasError(
                            'maxlength'
                          ))
                      "
                    >
                      Routing Number must be 9 digits.
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel">
                  <label> Bank Name </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Bank Name"
                      formControlName="bankName"
                      disabled
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['bankName'].touched &&
                        bankDetailsForm.controls['bankName'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
                <div class="card_panel full">
                  <label> Transaction Number </label>
                  <span>
                    <input
                      type="text"
                      placeholder="Transaction Number"
                      formControlName="transactionNumber"
                    />
                    <mat-error
                      *ngIf="
                        bankDetailsForm.controls['transactionNumber']
                          .touched &&
                        bankDetailsForm.controls[
                          'transactionNumber'
                        ].hasError('required')
                      "
                    >
                      This is required
                    </mat-error>
                  </span>
                </div>
              </div>
            </form>
          </mat-tab>
          <mat-tab label="Check" *ngIf="!refundToDefaultCard && totalPrice < 0">
            <form [formGroup]="chequeDetailForm">
              <div class="card_detail">
                <div class="card_panel full">
                  <label> Check Number</label>
                  <span>
                    <input
                      type="text"
                      placeholder="**** **** **** ****"
                      formControlName="checkNumber"
                      mask="0000*"
                    />
                    <mat-error
                      *ngIf="
                        chequeDetailForm.controls['checkNumber'].touched &&
                        chequeDetailForm.controls['checkNumber'].hasError(
                          'required'
                        )
                      "
                    >
                      This is required
                    </mat-error>
                    <mat-error
                      *ngIf="
                        chequeDetailForm.controls['checkNumber'].touched &&
                        chequeDetailForm.controls['checkNumber'].hasError(
                          'minlength'
                        )
                      "
                    >
                      Check Number must be minimum 4 digits.
                    </mat-error>
                  </span>
                </div>
              </div>
            </form>
          </mat-tab>
        </mat-tab-group>
      </div>
      
      <div class="flexwrap" style="margin-top: 10px;">
        <div class="lower_sec" *ngIf="itemList?.length > 0">
          <p>Total Optional Item Amount: <span [ngStyle]="{'color':totalPrice < 0 ?'red':'green' }">{{totalPrice | currency}}</span></p>
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" style="width:100%;">
            <button mat-button class="can-button" (click)="step = 1" *ngIf="!loading"><span>Back</span></button>
            <button mat-button class="sub-button"
            (click)="checkPaymentDetails()" *ngIf="!loading">{{totalPrice >= 0 ? 'Charge' : 'Refund'}}</button>
            <img [src]="assetsUrl + 'loder.gif'" alt="loaderImg" width="150" height="30" class="loadimg" *ngIf="loading" />
          </div>
        </div>
      </div>
    </div>
    
   
</div>
  
